class AuthApis {
  static readonly loginByEmail = '/api/system-users/request-login-otp/';
  static readonly loginByNationalId = '/api/system-users/request-login-otp/v1/';
  static readonly loginWithout2FA = '/api/system-users/get-token-without-2fa/';
  static readonly verifyOtp = '/api/system-users/verify-login-otp/';
  static readonly forgotPassword = '/api/system-users/password-reset-link/';

  //
  static readonly inviteInvestor = '/api/system-users/invite-investor/';
}

export default AuthApis;
